module.exports = __webpack_public_path__ + "static/media/12.c55dbeb9.jpg";